import React, { useState } from 'react';
import { Modal } from './ui/Modal';
import { Button } from './ui/Button';
type ModalType = 'terms' | 'privacy' | 'contact' | null;
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  const closeModal = () => setOpenModal(null);
  return <footer className="bg-sage text-cream py-16 text-center text-sm border-t border-gold/20" data-id="element-162">
      <div className="container mx-auto px-4" data-id="element-163">
        <div className="mb-8" data-id="element-164">
          <h2 className="text-2xl font-serif font-bold text-gold mb-2" data-id="element-165">
            Protocolo Vientre Plano 40+
          </h2>
          <p className="text-cream/60" data-id="element-166">El placer que nutre</p>
        </div>

        <div className="flex flex-wrap justify-center gap-8 mb-12" data-id="element-167">
          <button onClick={() => setOpenModal('terms')} className="text-cream/80 hover:text-gold transition-colors" data-id="element-168">
            Términos y Condiciones
          </button>
          <button onClick={() => setOpenModal('privacy')} className="text-cream/80 hover:text-gold transition-colors" data-id="element-169">
            Política de Privacidad
          </button>
          <button onClick={() => setOpenModal('contact')} className="text-cream/80 hover:text-gold transition-colors" data-id="element-170">
            Contacto
          </button>
        </div>

        <p className="text-xs text-cream/40 max-w-3xl mx-auto leading-relaxed mb-8" data-id="element-171">
          Descargo de responsabilidad: Este producto no sustituye el
          asesoramiento médico profesional. Los resultados pueden variar según
          cada persona. Si tenés condiciones médicas preexistentes, consultá a
          tu médico antes de comenzar cualquier cambio en tu alimentación.
        </p>

        <p className="text-cream/60" data-id="element-172">
          © {new Date().getFullYear()} Protocolo Vientre Plano 40+. Todos los
          derechos reservados.
        </p>
      </div>

      {/* Modals */}
      <Modal isOpen={openModal === 'terms'} onClose={closeModal} title="Términos y Condiciones" data-id="element-173">
        <div className="space-y-4 text-left" data-id="element-174">
          <p data-id="element-175">
            <strong data-id="element-176">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString()}
          </p>

          <h3 className="text-lg font-bold text-sage mt-6" data-id="element-177">
            1. Aceptación de los Términos
          </h3>
          <p data-id="element-178">
            Al acceder y utilizar el producto digital "Protocolo Vientre Plano
            40+" (en adelante, "el Producto"), usted acepta estar sujeto a estos
            Términos y Condiciones. Si no está de acuerdo con alguna parte de
            estos términos, no debe utilizar el Producto.
          </p>

          <h3 className="text-lg font-bold text-sage mt-6" data-id="element-179">
            2. Descripción del Producto Digital
          </h3>
          <p data-id="element-180">
            El Producto es un programa educativo digital enfocado en nutrición y
            bienestar, creado por "El Placer que Nutre". Incluye guías, recetas
            y material en formato digital. No se enviará ningún producto físico.
          </p>

          <h3 className="text-lg font-bold text-sage mt-6" data-id="element-181">
            3. Propiedad Intelectual
          </h3>
          <p data-id="element-182">
            Todo el contenido incluido en el Producto (textos, gráficos,
            logotipos, imágenes, audios, videos, descargas digitales y
            compilaciones de datos) es propiedad de "El Placer que Nutre" y está
            protegido por las leyes de propiedad intelectual e industrial. Queda
            estrictamente prohibida su reproducción, distribución, modificación
            o uso comercial sin autorización expresa por escrito.
          </p>

          <h3 className="text-lg font-bold text-sage mt-6" data-id="element-183">
            4. Política de Reembolso
          </h3>
          <p data-id="element-184">
            Ofrecemos una garantía de satisfacción de 7 días. Si dentro de los
            primeros 7 días posteriores a su compra usted considera que el
            Producto no cumple con sus expectativas, puede solicitar un
            reembolso completo enviando un correo a nuestro equipo de soporte.
            Pasados los 7 días, no se emitirán reembolsos bajo ninguna
            circunstancia.
          </p>

          <h3 className="text-lg font-bold text-sage mt-6" data-id="element-185">
            5. Limitación de Responsabilidad (Descargo Médico)
          </h3>
          <p data-id="element-186">
            La información proporcionada en el Producto tiene fines puramente
            educativos e informativos y{' '}
            <strong data-id="element-187">
              no constituye consejo médico, diagnóstico ni tratamiento
            </strong>
            . Siempre debe consultar a un médico o profesional de la salud
            calificado antes de comenzar cualquier dieta, programa de ejercicios
            o hacer cambios en su estilo de vida, especialmente si tiene
            condiciones médicas preexistentes. "El Placer que Nutre" no se hace
            responsable de ningún efecto adverso, lesión o consecuencia que
            resulte del uso o la aplicación de la información contenida en el
            Producto.
          </p>

          <h3 className="text-lg font-bold text-sage mt-6" data-id="element-188">
            6. Modificaciones
          </h3>
          <p data-id="element-189">
            Nos reservamos el derecho de modificar estos Términos y Condiciones
            en cualquier momento. Los cambios entrarán en vigor inmediatamente
            después de su publicación. Es su responsabilidad revisar
            periódicamente estos términos.
          </p>

          <h3 className="text-lg font-bold text-sage mt-6" data-id="element-190">7. Ley Aplicable</h3>
          <p data-id="element-191">
            Estos Términos y Condiciones se regirán e interpretarán de acuerdo
            con las leyes aplicables en la jurisdicción correspondiente a "El
            Placer que Nutre", sin dar efecto a ningún principio de conflictos
            de leyes.
          </p>
        </div>
      </Modal>

      <Modal isOpen={openModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" data-id="element-192">
        <div className="space-y-4 text-left" data-id="element-193">
          <p data-id="element-194">
            <strong data-id="element-195">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString()}
          </p>

          <h3 className="text-lg font-bold text-sage mt-6" data-id="element-196">
            1. Información que Recopilamos
          </h3>
          <p data-id="element-197">
            Recopilamos información personal que usted nos proporciona
            voluntariamente al realizar una compra, suscribirse a nuestro
            boletín o contactarnos. Esto puede incluir su nombre, dirección de
            correo electrónico y datos de pago (procesados de forma segura por
            terceros).
          </p>

          <h3 className="text-lg font-bold text-sage mt-6" data-id="element-198">
            2. Uso de la Información
          </h3>
          <p data-id="element-199">Utilizamos la información recopilada para:</p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-200">
            <li data-id="element-201">Procesar sus transacciones y entregar el Producto.</li>
            <li data-id="element-202">
              Enviarle correos electrónicos relacionados con su compra (recibos,
              acceso, actualizaciones).
            </li>
            <li data-id="element-203">Mejorar nuestro sitio web y servicio al cliente.</li>
            <li data-id="element-204">
              Enviarle comunicaciones de marketing (si ha optado por
              recibirlas), de las cuales puede darse de baja en cualquier
              momento.
            </li>
          </ul>

          <h3 className="text-lg font-bold text-sage mt-6" data-id="element-205">
            3. Cookies y Tecnologías de Seguimiento
          </h3>
          <p data-id="element-206">
            Utilizamos cookies y tecnologías similares (como el Píxel de Meta)
            para mejorar su experiencia de navegación, analizar el tráfico del
            sitio y personalizar el contenido y los anuncios. Puede configurar
            su navegador para que rechace las cookies, pero esto podría afectar
            la funcionalidad del sitio.
          </p>

          <h3 className="text-lg font-bold text-sage mt-6" data-id="element-207">
            4. Compartir Información con Terceros
          </h3>
          <p data-id="element-208">
            No vendemos, intercambiamos ni transferimos a terceros su
            información personal identificable. Esto no incluye a los terceros
            de confianza que nos asisten en la operación de nuestro sitio web,
            la realización de nuestro negocio o la prestación de servicios a
            usted (como procesadores de pago), siempre que dichas partes
            acuerden mantener esta información confidencial.
          </p>

          <h3 className="text-lg font-bold text-sage mt-6" data-id="element-209">
            5. Seguridad de los Datos
          </h3>
          <p data-id="element-210">
            Implementamos una variedad de medidas de seguridad para mantener la
            seguridad de su información personal. Sin embargo, ninguna
            transmisión de datos por Internet o sistema de almacenamiento
            electrónico es 100% seguro, por lo que no podemos garantizar su
            seguridad absoluta.
          </p>

          <h3 className="text-lg font-bold text-sage mt-6" data-id="element-211">6. Sus Derechos</h3>
          <p data-id="element-212">
            Usted tiene derecho a acceder, corregir, actualizar o solicitar la
            eliminación de su información personal en cualquier momento. Para
            ejercer estos derechos, por favor contáctenos a través del
            formulario de contacto.
          </p>
        </div>
      </Modal>

      <Modal isOpen={openModal === 'contact'} onClose={closeModal} title="Contacto" data-id="element-213">
        <div className="text-left" data-id="element-214">
          <p className="mb-6" data-id="element-215">
            ¿Tenés alguna duda o consulta? Completá el formulario a continuación
            y nos pondremos en contacto con vos a la brevedad.
          </p>

          <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-216">
            <div data-id="element-217">
              <label htmlFor="name" className="block text-sm font-medium text-sage mb-1" data-id="element-218">
                Nombre
              </label>
              <input type="text" id="name" className="w-full px-4 py-2 border border-sage/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold/50 bg-white text-sage" placeholder="Tu nombre completo" data-id="element-219" />
            </div>

            <div data-id="element-220">
              <label htmlFor="email" className="block text-sm font-medium text-sage mb-1" data-id="element-221">
                Email
              </label>
              <input type="email" id="email" className="w-full px-4 py-2 border border-sage/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold/50 bg-white text-sage" placeholder="tu@email.com" data-id="element-222" />
            </div>

            <div data-id="element-223">
              <label htmlFor="message" className="block text-sm font-medium text-sage mb-1" data-id="element-224">
                Mensaje
              </label>
              <textarea id="message" rows={4} className="w-full px-4 py-2 border border-sage/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold/50 bg-white text-sage resize-none" placeholder="¿En qué podemos ayudarte?" data-id="element-225"></textarea>
            </div>

            <Button variant="primary" className="w-full mt-4" data-id="element-226">
              Enviar Mensaje
            </Button>
          </form>
        </div>
      </Modal>
    </footer>;
}